export default {
  namespace: 'returnList',
  state: {
    tab: '1',
  },
  reducers: {
    tabswitch( state, { payload: tab } ) {
      return {...state, tab}
    },
  },
};
